import gql from 'graphql-tag';

// Lean directory of every company's feed-enablement config, for the Admin
// Integrations ledger view. The configs are small JSON rule maps (routing
// keys + pipelineMode), not the mapping docs — those live in Dynamo.
export const ListCompanyProcessingConfigs = gql`
	query ListCompanyProcessingConfigs($limit: Int, $nextToken: String) {
		listCompanies(limit: $limit, nextToken: $nextToken) {
			items {
				id
				name
				SFTPProcessingConfig
				ATSProcessingConfig
			}
			nextToken
		}
	}
`;
